<template>
<nav class="navbar">
    <a href="index.html" class="navbar-logo"></a>
    <ul class="navbar-menu">
      <li>
        <a href="javascript:void(0)" :class="{'active': pathName == '/' || pathName == ''}">
          <router-link to="/">首页</router-link>
        </a>
      </li>
      <li>
        <a href="javascript:void(0)" :class="{'active': pathName == '/About'}">
          <router-link to="/About">关于我们</router-link>
        </a>
      </li>
      <li>
        <a href="javascript:void(0)" :class="{'active': pathName == '/Goods'}">
          <router-link to="/Goods">商城</router-link>
        </a>
      </li>
      <li>
        <a href="javascript:void(0)" :class="{'active': pathName == '/Contact'}">
          <router-link to="/Contact">联系我们</router-link>
        </a>
      </li>
    </ul>
  </nav>
</template>

<script>
import CommonMixin from '../../mixins/common'
export default {
  mixins: [CommonMixin],
  name: 'M-Header',
  created () {

  },
  data () {
    return {
      pathName: ''
    };
  },
  computed: {
  },
  methods: {
  }, 
  watch: {
    '$route'(to, from) {
      console.log('to', to)
      this.pathName = to.path
    }
  },
  mounted() {
  }
};
</script>

<style scoped lang="less" >

/* ========== 导航栏 ========== */
.navbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: #fff;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 100px;
}

.navbar-logo {
  font-size: 24px;
  font-weight: 700;
  color: #E50012;
  text-decoration: none;
}

.navbar-menu {
  display: flex;
  gap: 40px;
  list-style: none;
  max-width: 1200px;
}
.navbar-menu li{
  margin: 0 5px;
}

.navbar-menu a {
  text-decoration: none;
  font-size: 16px;
  font-weight: 500;
  padding: 10px 0px;
  position: relative;
  transition: var(--transition);
  color: #000;
  font-weight: 600;
}

.navbar-menu .active a{
  color: #E50012;
}

.navbar-menu a:hover {
  color: #E50012;
}

.navbar-menu a.active {
  color: #E50012;
}

.navbar-menu a.active::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: #E50012;
}

@media (max-width: 768px) {
  .navbar {
    padding: 0 20px;
    height: 50px;
  }
  
  .navbar-menu a {
    font-size: 14px;
  }
  .navbar-logo{
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/header/Header.vue